import { IpoTouchCheckService } from '@ip-only/front-end-library';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import { GroupsApiService } from '../hub/api/group-api.service';
import { UserService } from '../hub/api/user.service';
import { tryFetchHubSession } from './keycloak-cookie';
import { loginFlow } from './login-flow';

export function initializeKeycloak(
  keycloak: Keycloak,
  touchCheckService: IpoTouchCheckService,
  userService: UserService,
  groupService: GroupsApiService
): () => Promise<boolean> {
  return async (): Promise<boolean> => {
    const initOptions: KeycloakInitOptions = tryFetchHubSession()
      ? { onLoad: 'check-sso' }
      : {};

    let isLoggedIn = false;

    try {
      isLoggedIn = await keycloak.init(initOptions);
    } catch (error) {
      console.error('Keycloak initialization error:', error);
      return false;
    }

    try {
      touchCheckService.init();
    } catch {
      // Touch capability detection is optional and must not block login.
    }

    if (isLoggedIn) {
      try {
        await loginFlow(keycloak, userService, groupService);
      } catch {
        await keycloak.logout();
      }
    }

    return isLoggedIn;
  };
}
